import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const ARViewPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  
  // 如果用户未登录，重定向到登录页面
  if (!user) {
    navigate('/login');
    return null;
  }
  
  return (
    <div className="space-y-8">
      <section className="cyber-panel p-6 rounded-lg bg-gradient-to-r from-cyber-dark to-black">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <h1 className="text-3xl font-xianxia text-cyber-primary mb-2 cyber-title">AR法器展示</h1>
            <p className="text-cyber-light">
              通过增强现实技术，体验赛博法器的视觉效果与功能
            </p>
          </div>
        </div>
      </section>
      
      <div className="cyber-panel p-6 rounded-lg">
        <div className="text-center p-8">
          <div className="text-5xl text-cyber-accent mb-6">
            <i className="fas fa-vr-cardboard"></i>
          </div>
          <h2 className="text-2xl font-cyber text-cyber-primary mb-4">AR功能准备中</h2>
          <p className="text-cyber-light mb-4">我们的赛博法器AR展示功能正在紧张开发中，敬请期待...</p>
          <p className="text-cyber-light mb-6">未来您将可以通过AR技术查看和体验各种赛博法器的3D模型和功能演示。</p>
          <button
            className="cyber-button"
            onClick={() => navigate('/artifact-refining')}
          >
            返回炼器系统
          </button>
        </div>
      </div>
    </div>
  );
};

export default ARViewPage;
